import { render, staticRenderFns } from "./lawsuit-manage.vue?vue&type=template&id=7c07198d"
import script from "./lawsuit-manage.vue?vue&type=script&lang=ts"
export * from "./lawsuit-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports